import {
  WIDGET_BUTTON_ID,
  WIDGET_COLOR_ATTRIBUTE,
  WIDGET_OWNER_ID_ATTRIBUTE,
  WIDGET_GOOGLE_ANALYTICS_ID_ATTRIBUTE,
  WIDGET_LANGUAGES_ATTRIBUTE,
  WIDGET_LOGO_ATTRIBUTE,
  WIDGET_TERMS_AND_CONDITIONS_ATTRIBUTE,
  WIDGET_PRIVACY_POLICY_ATTRIBUTE,
  WIDGET_CLICK_HANDLER
} from 'constants/widget';

export const generateWidgetButton = ({
  businessOwnerId,
  color,
  googleAnalyticsId,
  languages,
  logo,
  productId,
  itemType,
  privacyPolicy,
  termsAndConditions
}) => {
  const attributes = {
    id: WIDGET_BUTTON_ID,
    [WIDGET_OWNER_ID_ATTRIBUTE]: businessOwnerId,
    [WIDGET_COLOR_ATTRIBUTE]: color,
    [WIDGET_GOOGLE_ANALYTICS_ID_ATTRIBUTE]:
      googleAnalyticsId && googleAnalyticsId.length ? googleAnalyticsId : null,
    [WIDGET_LANGUAGES_ATTRIBUTE]: languages.length ? languages : null,
    [WIDGET_LOGO_ATTRIBUTE]: logo,
    [WIDGET_PRIVACY_POLICY_ATTRIBUTE]: privacyPolicy,
    [WIDGET_TERMS_AND_CONDITIONS_ATTRIBUTE]: termsAndConditions,
    onClick: WIDGET_CLICK_HANDLER
  };

  if (itemType) {
    const type = itemType.toLowerCase();
    attributes[`data-horn-${type}-id`] = productId;
  }

  let widgetAttrs = '';

  Object.keys(attributes).forEach(key => {
    const value = attributes[key];
    widgetAttrs += `${key}="${value}" `;
  });

  return `<button ${widgetAttrs}>Book now</button>`;
};
